(function () {
  angular.module('binky.core.api.utils', ['binky.core.lodash', 'binky.core.organizations']);
})();
